import { render, staticRenderFns } from "./FooterComponentWconat.vue?vue&type=template&id=5ac66068&scoped=true"
import script from "./FooterComponentWconat.vue?vue&type=script&lang=ts"
export * from "./FooterComponentWconat.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponentWconat.vue?vue&type=style&index=0&id=5ac66068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac66068",
  null
  
)

export default component.exports